import axios from "axios";
import { VAIPEDE_API } from "./api";

// Axios isolado para o entregador (token diferente)
export const entAxios = axios.create({ baseURL: VAIPEDE_API });
entAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("vaipede_entregador_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
entAxios.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("vaipede_entregador_token");
      localStorage.removeItem("vaipede_entregador");
      if (!window.location.pathname.includes("/vaipede/entregador/login")) {
        window.location.href = "/vaipede/entregador/login";
      }
    }
    return Promise.reject(err);
  }
);
